import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import Breadcrumbs from "examples/Breadcrumbs";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import {
  useSoftUIController,
  setTransparentNavbar,
  setMiniSidenav,
} from "context";
import ApnaSelect from "components/ApnaSelect/location";
import { getLocationData } from "api/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { setFilterLocation } from "api/searchSlice";
import { getSearch } from "api/searchSlice";

function DashboardNavbar({ absolute, light, isMini }) {

  const pathname = useLocation().pathname;
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller;
  const route = useLocation().pathname.split("/").slice(1);
  const isToken = localStorage.getItem("token");
  const dispatcho = useDispatch();
  const locations = useSelector((state) => state.commonSlice?.locations);
  const [allLocations, setAllLocations] = useState([]);
  const userTheme = useSelector((state) => state.commonSlice.theme);
  useEffect(() => {
    if (pathname == "/dashboard" || pathname == "/couponReports") {
      dispatcho(getLocationData());
    }
  }, []);

  useEffect(() => {
    if (locations) {
      setAllLocations([]);
      locations &&
        locations.length > 0 &&
        locations.map((location) => {
          setAllLocations((prev) => [...prev, { _id: location?.locationId, name: location?.locationName }]);
        })
    }
  }, [locations])

  const onChangeLocation = (e) => {
    dispatcho(setFilterLocation(e.target.value));
  }

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    handleTransparentNavbar();
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const onSearchChange = (e) => {
    dispatcho(getSearch(e.target.value));
  }



  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <SoftBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </SoftBox>

        {isMini ? null : (
          <SoftBox sx={(theme) => navbarRow(theme, { isMini })}>
            <SoftBox mr={2}>
              {
                (pathname == '/dashboard' || pathname == "/couponReports") && locations &&
                locations.length > 0 &&
                <ApnaSelect
                  origin="location"
                  options={allLocations}
                  onChange={onChangeLocation}
                />
              }
            </SoftBox>

            {/* {(pathname == '/offers') &&
            <>
              <SoftBox pr={1} mt={pathname == '/couponReports'?4:''}>
              
                <SoftInput
                  onChange={onSearchChange}
                  placeholder="Search here..."
                  icon={{ component: "search", direction: "left" }}
                />
                <SoftBox
                >
                
                </SoftBox>
               
              </SoftBox>
               
              </>
            } */}

            <SoftBox color={light ? "white" : "inherit"}>
              <Link to={isToken ? "/profile" : "/login"}>
                <IconButton sx={navbarIconButton} size="small">
                  <Icon
                    sx={({ palette: { dark, white } }) => ({
                      color: userTheme=='dark'?white.main:'black',
                    })}
                  >
                    settings
                  </Icon>
                  {
                    isToken ? <SoftTypography
                      variant="button"
                      fontWeight="medium"
                      color={light ? "white" : "dark"}
                    >
                      Settings
                    </SoftTypography> : <SoftTypography
                      variant="button"
                      fontWeight="medium"
                      color={light ? "white" : "dark"}
                    >  Sign in </SoftTypography>
                  }
                </IconButton>
              </Link>
              <IconButton
                size="small"
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon className={light ? "text-white" : "text-dark"}>
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              {/* <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon>settings</Icon>
              </IconButton> */}
              {/*
               <IconButton
                size="small"
                variant="gradient"
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                onClick={handleOpenMenu}
              >
                <Icon className={light ? "text-white" : "text-dark"}>notifications</Icon>
              </IconButton> */}
              {/* {renderMenu()} */}
            </SoftBox>
          </SoftBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
